import { useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import { Link, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { useGetProServiceByIdQuery } from "../../features/api/proserviceApi";
import { getuser } from "../../components/CommonDateFormat";
import { API_BASE_URL } from "../../components/baseUrl";
import headerLogo from "../../asset/johura_logo.png";

function ProserviceReport() {
  const [visible, setVisible] = useState(false);
  const user = getuser();
  // useRef for report
  const componentRef = useRef();

  const { id } = useParams();

  // get service product by id
  const { data } = useGetProServiceByIdQuery(id, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const productInfo = data;

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  }

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto py-8">
      <ReactToPrint
        trigger={() => (
          <h1 className="cursor-pointer flex items-center absolute right-5 gap-x-1 text-red-500">
            <AiFillPrinter /> Print
          </h1>
        )}
        content={() => componentRef.current}
        pageStyle={`
          @page {
            size: A4;
            margin: 1cm;
          }

          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            .no-print {
              display: none !important;
            }
          }
        `}
      />

      <div className="flex gap-6 items-center justify-between my-4">
        <div className="flex items-center gap-x-2">
          <input
            onClick={() => setVisible(!visible)}
            type="checkbox"
            className="cursor-pointer"
          />
          <span>Pad logo</span>
        </div>
        <Link
          to="/dashboard/product-services"
          className="border bg-blue-500 px-2 rounded text-white"
        >
          Back
        </Link>
      </div>

      <div className=" border p-5">
        <div ref={componentRef}>
          <div className="h-[90px]">
            {visible && (
              <div>
                <img src={headerLogo} className="h-[90px] w-full" alt="" />
                <div className="border-b border-green-500 my-1" />
                <div className="border-b border-red-400" />
              </div>
            )}
          </div>
          <div className="">
            <div className="flex justify-center my-4">
              <p className="bg-gray-200 p-1 mt-2 text-sm font-bold w-fit">
                CLAIM FORM INFORMATION
              </p>
            </div>

            <div className="">
              <div className="flex items-end justify-between">
                <div className="mt-4 text-sm">
                  <h1 className="font-bold">Client Information</h1>
                  <div className="flex gap-2">
                    <p className="font-semibold w-[80px]"> Client Name</p> :
                    <p className="font-bold">{productInfo?.client}</p>
                  </div>
                  <div className="flex gap-2">
                    <p className="font-semibold  w-[80px] "> Mobile</p> :
                    <p className="font-bold">{productInfo?.mobile}</p>
                  </div>
                  <div className="flex gap-2 ">
                    <p className="font-semibold  w-[80px] "> Address </p> :
                    <p className="font-bold">{productInfo?.address}</p>
                  </div>
                </div>
                <h2>
                  <span className="font-bold">Claim Date:</span>{" "}
                  {formatDate(productInfo?.claim_date)}
                </h2>
              </div>
            </div>

            <div className="flex justify-between gap-2 my-2 pb-1"></div>
            <div>
              <table className="min-w-full">
                <thead>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%]">
                      Job No.
                    </th>
                    <td className="border border-gray-400 pl-2">
                      {productInfo?.job_no}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Brand
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.brand}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Product
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.product}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Model
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.model}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Serial No.
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.slNo}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Complain Type
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.complain_type}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Warranty
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.war_type}
                    </td>
                  </tr>

                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Product Revceived Date
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.p_r_date
                        ? formatDate(productInfo?.p_r_date)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Nature of Complain
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.nature_claim}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Accessories
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.accessories}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Previous Job No
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.prev_jobNo || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Previous Job Date
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.prev_job_date
                        ? formatDate(productInfo?.prev_job_date)
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Receive Location
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.p_rcve_loc}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Status
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.delivery_status}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Delivery Date (Approximate)
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {formatDate(productInfo?.del_app_date)}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Received By
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.rcv_by}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Type
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.service_type}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 w-[50%] text-sm">
                      Service Details
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.service_details
                        ?.split("\n")
                        .map((item, index) => (
                          <div key={index}>{item}</div>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-gray-400 text-left pl-2 h-12 w-[50%] text-sm">
                      Remarks
                    </th>
                    <td className="border border-gray-400 pl-2 text-sm">
                      {productInfo?.remarks}
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="flex justify-between mt-16">
              <p>
                <span className="font-bold text-sm border-t border-black">
                  Received by Client
                </span>
              </p>
              <p className="flex flex-col">
                <span className="font-bold text-sm">
                  Prepared By: {productInfo?.created_by}
                </span>
              </p>
              <p>
                <img
                  src={`${API_BASE_URL}/uploads/${user?.signature}`}
                  alt=""
                  className="w-12 h-12 mx-auto"
                />
                <span className="font-bold text-sm border-t border-black">
                  For Johura Endomed Solution
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProserviceReport;
